module.exports = __webpack_public_path__ + "static/bcg-bf222a6ebfeb3a1c40491fd0b9319664.jpg";